<template>
    <el-container direction="vertical" class="debts">
        <el-row class="header">
            <el-col>
                <div class="title">
                    {{ title }}
                </div>
            </el-col>
        </el-row>
        <el-row class="main" v-loading="loading">
            <el-col>
                <div v-for="element in debts" :key="element.id">
                    <div class="row" @click="handleElementClick(element)">
                        <div class="name">
                            <i class="el-icon-caret-bottom" v-if="element.isOpened"></i>
                            <i class="el-icon-caret-right" v-else></i>
                            {{ element.name }}:
                        </div>
                        <div class="amount pl15">
                            {{ formatFinance(element.debtsTotal) }} руб.
                        </div>
                    </div>
                    <template v-if="isDealsReady && element.deals.length && element.isOpened">
                        <delivery-deals-debts
                            :debts="element.deals"
                            :factory-name="element.name"
                            :factory-id="element.id"
                            @updateDeals="updateDeals"
                            v-if="element.isOpened"
                        />
                    </template>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import '@/assets/styles/debts.scss';
import localReferences from '@/helpers/localReferences';
import DeliveryDealsDebts from '@/components/debts/DeliveryDealsDebts';

export default {
    name: 'DebtsDelivery',
    data() {
        return {
            localReferences,
            title: 'Неподтвержденные долги Доставки',
            loading: false,
            isDealsReady: false,
            debts: {
                operation_type_id: 0,
                operation_status_id: 0,
                pay_type_id: localReferences.payTypesFull.cash,
                detail_id: localReferences.incomeDetails.delivery,
                received_by_type: localReferences.incomeRecievedByType.factory,
                received_by_id: 0,
                created_by_id: this.$store.state.auth.employerId,
                received_from_type: 'contact',
                received_from_id: 0,
                date: '',
                deal_id: 0,
                amount: 0,
                comment: 'Приход от клиента'
            }
        };
    },
    components: {
        DeliveryDealsDebts
    },
    mounted() {
        this.getDebts();
    },
    methods: {
        handleElementClick(element) {
            if (element.isOpened === false) {
                const opened = this.debts.find(element => element.isOpened);
                if (opened) {
                    opened.isOpened = false;
                }
            }
            element.isOpened = !element.isOpened;
        },
        formatFinance(num) {
            return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') : 0;
        },
        async getDebts(selectedFactoryId) {
            this.loading = true;
            this.isDealsReady = false;
            try {
                const response = await this.$store.dispatch('debts/getDeliveryDebts');
                let selected = false;
                if (selectedFactoryId !== undefined) {
                    selected = selectedFactoryId;
                }
                const result = [];
                response.forEach(elem => {
                    result.push({
                        id: +elem.factory.id,
                        name: elem.factory.name,
                        isOpened: !!((selected && selected === +elem.factory.id)),
                        debtsTotal: elem.deals.reduce((total, deal) => total + deal.delivery_balance, 0),
                        deals: elem.deals.map(deal => {
                            return {
                                deal_id: deal.deal_id,
                                measurement_date: deal.measurement_date,
                                installation_date: deal.installation_date,
                                contract: deal.contract,
                                contact_id: deal.contact_id,
                                contact_name: deal.contact_name,
                                contact_phone: deal.contact_phone,
                                address: deal.address,
                                debt: deal.delivery_balance,
                                recieved_by_delivery: deal.recieved_by_delivery
                            };
                        })
                    });
                });
                this.debts = result;
            } catch (error) {
                console.log(error.message);
            } finally {
                this.loading = false;
                this.isDealsReady = true;
            }
        },
        updateDeals(factoryId) {
            this.getDebts(factoryId);
        }
    }
};
</script>
